var exports = {
  "AS": "xfb577c5e--514af1--item",
  "wm": "xfb577c5e--514af1--logo",
  "Wk": "xfb577c5e--514af1--logo-img",
  "W9": "xfb577c5e--514af1--logo-placeholder",
  "Vk": "xfb577c5e--514af1--icon-out",
};

module.exports = exports;
